import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import DataTable from "react-data-table-component";
import axiosInstance from "../axiosConfig";

const ADDRMReturn = () => {
  const [returns, setReturns] = useState([]);
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [departments, setDepartments] = useState([]); // Departments for dropdown
  const [formData, setFormData] = useState({
    LOT_ID: "",
    RM_Quantity: "",
    Remarks: "",
    DamageQTY: ""
  });

  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);

  const fetchReturns = async () => {
    try {
      const response = await axiosInstance.get("/api/rm-return");
      setReturns(response.data);
    } catch (error) {
      console.error("Error fetching RM returns:", error);
    }
  };
      // Fetch departments
  const fetchDepartments = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/departments");
      setDepartments(response.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
      alert("Failed to fetch departments.");
    }
  }, []);

  useEffect(() => {
    fetchReturns();
    fetchDepartments();
  }, [ fetchDepartments]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const user = JSON.parse(localStorage.getItem("user"));
    const dataToSend = {
      ...formData,
      CreatedBy: user?.Name || "Unknown"
    };

    try {
      await axiosInstance.post("/api/rm-return", dataToSend);
      showAlert("RM Return added successfully","success");
      setShowModal(false);
      setFormData({ LOT_ID: "", RM_Quantity: "", Remarks: "", DamageQTY: "", Department:"" });
      fetchReturns();
    } catch (error) {
      console.error("Error submitting RM return:", error);
      alert("Failed to submit RM return.");
    }
  };

  const handleViewImage = (imagePath) => {
    setSelectedImage(`${axiosInstance.defaults.baseURLPath}/uploads/${imagePath}`);
    setShowImageModal(true);
  };
  
  const showAlert = (message, type) => {
    const alertPlaceholder = document.getElementById("alertPlaceholder");
    const alertHTML = `
      <div class="alert alert-${type} alert-dismissible fade show" role="alert">
        <strong>${type === "success" ? "Success!" : "Error!"}</strong> ${message}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>`;
    alertPlaceholder.innerHTML = alertHTML;
    setTimeout(() => {
      alertPlaceholder.innerHTML = "";
    }, 2000);
  };
  const columns = [
     { name: "Department", selector: (row) =>(
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row.Department}
      >
      {row.Department || "N/A"}
      </span>
    ), sortable: true },
    { name: "LOT ID", selector: (row) => row.LOT_ID, sortable: true },
    { name: "Quantity", selector: (row) => row.RM_Quantity, sortable: true },
    { name: "Damage QTY", selector: (row) => row.DamageQTY || "N/A", sortable: true },
    { name: "Remarks", selector: (row) =>(
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row.Remarks}
      >
      {row.Remarks || "N/A"}
      </span>
    ), sortable: true },
    {
      name: "Status",
      selector: (row) => (
        <span
          style={{
            padding: "4px 12px",
            borderRadius: "6px",
            fontWeight: "bold",
            display: "inline-block",
            color:
              row.Status === "Confirmed"
                ? "#155724"
                : row.Status === "Rejected"
                ? "#721c24"
                : "#856404",
            backgroundColor:
              row.Status === "Confirmed"
                ? "#d4edda"
                : row.Status === "Rejected"
                ? "#f8d7da"
                : "#fff3cd"
          }}
        >
          {row.Status}
        </span>
      ),
      sortable: true,
    },     
    { name: "RejectReason", selector: (row) => (
      <span
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={row.RejectReason}
      >
        { row.RejectReason || "N/A"}
      </span>
    ),
    sortable: true },
   
    {
      name: "Actions",
      cell: (row) =>
        row.ImagePath ? (
          <button
            className="btn btn-sm btn-outline-info"
            onClick={() => handleViewImage(row.ImagePath)}
          >
            View Image
          </button>
        ) : (
          <span className="text-muted">No Image</span>
        ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    },
    {
      name: "Date",
      selector: (row) => new Date(row.CreatedAt).toLocaleString("en-GB"),
      sortable: true
    },
  ];

  return (
    <div className="d-flex dashboard">
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1">
        <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{height:"-webkit-fill-available"}}>
          <div className="d-flex justify-content-end mb-3">
            <button className="btn btn-outline-primary" onClick={() => setShowModal(true)}>
              Add RM Return
            </button>
          </div>
          <DataTable columns={columns} data={returns} pagination />
        </main>
      </div>

      {/* Add Form Modal */}
      {showModal && (
          <>
          {/* Bootstrap Backdrop */}
         <div className="modal-backdrop fade show"></div>
 
         {/* Bootstrap Modal */}
        <div className="modal show" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add RM Return</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <form onSubmit={handleFormSubmit}>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Department</label>
                    <select
                      name="Department"
                      value={formData.Department}
                      onChange={handleInputChange}
                      className="form-control"
                      required
                    >
                      <option value="">Select Department</option>
                      {departments.map((dept, index) => (
                            <option key={index} value={dept}>
                              {dept}
                            </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">LOT ID</label>
                    <input
                      type="text"
                      name="LOT_ID"
                      value={formData.LOT_ID}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter LOT ID"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">RM Quantity</label>
                    <input
                      type="number"
                      name="RM_Quantity"
                      value={formData.RM_Quantity}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter RM Quantity"
                      step="0.01"
                      required
                    />
                  </div>
                   <div className="mb-3">
                    <label className="form-label">Damage Quantity</label>
                    <input
                      type="number"
                      name="DamageQTY"
                      value={formData.DamageQTY}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter Damage Quantity"
                      step="0.01"
                      required
                    />
                  </div>
                   <div className="mb-3">
                      <label className="form-label">Remarks</label>
                      <textarea
                        name="Remarks"
                        className="form-control"
                        rows={2}
                        value={formData.Remarks}
                        onChange={handleInputChange}
                        placeholder="Enter remarks"
                      />
                    </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary">Submit</button>
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        </>
      )}

      {/* View Image Modal */}
      {showImageModal && (
          <>
          {/* Bootstrap Backdrop */}
         <div className="modal-backdrop fade show"></div>
 
         {/* Bootstrap Modal */}
        <div className="modal show" style={{ display: "block" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Returned RM Image</h5>
                <button type="button" className="btn-close" onClick={() => setShowImageModal(false)}></button>
              </div>
              <div className="modal-body text-center">
                {selectedImage ? (
                  <img
                    src={selectedImage}
                    alt="Returned Material"
                    style={{ maxWidth: "100%", maxHeight: "500px" }}
                  />
                ) : (
                  <p>No image available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
        </>
      )}
    </div>
  );
};

export default ADDRMReturn;
